@import '../../../scss/global_v2_member_light-vars.css';

.requiredMessage {
  position: absolute;
  top: 100%;
  left: 0.75rem;
  color: var(--vip-color-text-error);
  font: var(--vip-typography-body-xs-regular);
  opacity: 1;
  transform: translateY(0);
  transition:
    transform 150ms ease,
    opacity 150ms ease;
}

.requiredMessage:empty {
  opacity: 0;
  transform: translateY(5px);
  pointer-events: none;
}
